module.exports = {
	"general.formats.dayFormattingPattern": "MMMM DD, YYYY",
	"general.formats.datePatternAPI": "YYYY-MM-DD",
	"general.formats.datePatternUI": "MM-DD-YYYY",
	"general.formats.shortDatePattern": "MMM DD",
	"general.formats.fullShortDatePattern": "MMM DD, YYYY",
	"general.formats.timePattern": "hh:mm a",
	"general.title": "{brandName}",
	"general.description": "Atención de salud fuera del hospital",
	"general.slogan.primary": "La red global para el compromiso del paciente",
	"general.slogan.secondary": "El compromiso del paciente - en cualquier lugar, en cualquier momento",
	"general.labels.you": "(You)",
	"general.labels.YO": "y.o.",
	"general.labels.noInternet": "Sin conexión a Internet",
	"general.labels.myProfile": "Mi perfil",
	"general.labels.profile": "Perfil",
	"general.labels.backToInvitation": "Volver al proceso de invitación",
	"general.labels.userNameExample": "JohnDoe_123 o Wolverine",
	"general.labels.userNameExplanation": "Apodo es un alias que se utilizará para identificarse en sus publicaciones. Sea creativo si prefiere ser anónimo.",
	"general.labels.pickItemLeft": "Elija un artículo que le gustaría ver en la barra lateral izquierda",
	"general.errors.404": "¡Vaya! No hay nada que ver aquí.",
	"general.toTop": "Ir a la cima",
	"general.success": "Éxito",
	"general.removedFromChat": "Has sido borrado de esta conversación.",
	"general.search.placeholder": "Buscar...",
	"general.search.patients": "Buscar pacientes...",
	"common.remove": "Retirar",
	"common.accept": "Aceptar",
	"common.decline": "Disminuir",
	"common.back": "Atrás",
	"common.cancel": "Anular",
	"common.save": "Guardar",
	"common.invite": "Enviar invitación",
	"common.terms": "Términos y Condiciones",
	"common.yes": "sí",
	"common.no": "no",
	"common.close": "Cerrar",
	"common.collapse": "Colapso",
	"common.myMessages": "Mi Consejo de Salud",
	"common.myCommunities": "Mis comunidades",
	"common.add": "Añadir",
	"common.clear": "Borrar",
	"common.optional": "(opcional)",
	"common.unassign": "Desasignar",
	"menu.healthboard": "Consejo de Salud",
	"menu.myCircles": "Mis Círculos",
	"menu.communities": "Comunidades",
	"messages.chat.empty.messages": "No tienes mensajes",
	"messages.chat.empty.users": "No hay usuarios para chatear",
	"messages.chat.empty.channels": "Sin canales para conectarse",
	"messages.chat.defaultUser": "INTRODUZCA EL NOMBRE DE USUARIO O NOMBRE DE UN USUARIO QUE DESEA AÑADIR A LA CONVERSACION",
	"messages.chat.searchAUser": "Buscar un usuario...",
	"messages.userProfile.familyMembers": "Miembros de la familia",
	"messages.userProfile.programServiceProviders": "Proveedores de programas/servicios",
	"messages.userProfile.singleProvider": "Proveedor de cuidado individual",
	"messages.userProfile.mainProvider": "Proveedor de cuidado principal",
	"messages.userProfile.memberProviderCircle": "Miembro",
	"messages.titles.familyTitleWithCounter": "Círculo familiar ({counter})",
	"messages.titles.providerTitleWithCounter": "Círculo de proveedores ({counter})",
	"messages.nav.tabs.patient": "Usuario General",
	"messages.nav.tabs.provider": "Proveedor",
	"messages.filterOptions.allPatients": "Todos los pacientes",
	"messages.filterOptions.myPatients": "Mis pacientes",
	"messages.statusFilterOptions.all": "Todos",
	"messages.statusFilterOptions.joined": "Unido",
	"messages.statusFilterOptions.notJoined": "No Unido",
	"messages.patientNotJoined.message": "El paciente no se ha unido todavía",
	"messages.patientNotJoined.resend": "Reenviar una invitación",
	"messages.patientNotJoined.invite": "Envia una invitacion",
	"messages.patientNotJoined.inviteSent": "Invitación enviada",
	"messages.patientNotJoined.checkContactInformationText": "Por favor confirme los detalles de contacto del paciente antes de enviar una invitación",
	"messages.patientNotJoined.inviteTitle": "Invitar Paciente",
	"messages.patientNotJoined.errors.emailAlreadyTaken": "Correo electrónico ya usado, por favor brinde otro",
	"messages.patientNotJoined.errors.emailInvalid": "El correo electrónico no es válido, por favor proporcione otro",
	"messages.patientNotJoined.errors.emailBlank": "El correo electrónico no puede estar en blanco",
	"messages.patientNotJoined.errors.phoneNumberAlreadyTaken": "Número de teléfono ya usado, por favor proporcione otro",
	"messages.patientNotJoined.errors.phoneNumberBlank": "El número de teléfono no puede estar en blanco",
	"messages.patientNotJoined.errors.phoneNumberInvalid": "El número de teléfono no es válido",
	"messages.titles.accessLevel": "Nivel De Acceso",
	"messages.titles.accessLevelTooltip": "El Acceso temporal se mantendrá únicamente en el período de sesiones en curso. El tiempo de espera de sesión es de 30 minutos desde la Última actividad.",
	"messages.titles.reasonForAssignment": "Motivo de la asignación",
	"messages.titles.selectReasonForAssignment": "Seleccione una razón para la asignación",
	"circle.assigned": "El proveedor ha sido asignado exitosamente",
	"circle.unassigned": "El proveedor ha sido sin asignar con éxito",
	"circle.confirmUnassigned": "Lo sentimos, pero no has sido asignado a este paciente y no tienes más permisos para acceder a esta página",
	"circles.empty": "No tienes círculos",
	"circles.empty.navigation": "No hay círculos para navegar",
	"circles.invites.cancelInvite": "Cancelar invitación",
	"circles.invites.confirmCancel": "Sí estoy seguro",
	"circles.invites.declineCancel": "No",
	"circles.invites.inviteSent": "Invitación enviada",
	"circles.invites.invitedCaregiver": "Cuidador (pendiente)",
	"circles.invites.family.success": "La invitación de miembro de familia ha sido enviada",
	"circles.invites.caregiver.success": "La invitación del cuidador ha sido enviada",
	"circles.invites.provider.success": "Proveedor fue agregado al círculo",
	"circles.invites.family.accept": "Te has unido al círculo familiar",
	"circles.invites.family.decline": "Has rechazado la invitación del círculo familiar",
	"circles.invites.caregiver.accept": "Usted ha aceptado la función de cuidador",
	"circles.invites.caregiver.decline": "Has rechazado la función de cuidador",
	"circles.provider.remove": "El proveedor fue eliminado de su círculo de proveedores",
	"circles.provider.leave": "Saliste del círculo de proveedores",
	"circles.family.remove": "El usuario fue eliminado de tu círculo familiar",
	"circles.family.leave": "Has dejado el círculo familiar",
	"circles.invites.caregiver.error": "El usuario invitado ya es un cuidador del paciente.",
	"circles.invites.text.ProviderInvitesCaregiver": "lo ha invitado a ser el cuidador de {patientName} en {brandName}. Como cuidador, podrá responder encuestas en nombre de {patientName} y utilizar {brandName} en nombre de {patientName}. Usted acepta ser cuidador de {patientName}.",
	"circles.invites.title": "Invitar miembro",
	"circles.invites.subtitle": "por correo electrónico o teléfono",
	"circles.invites.role": "Seleccionar relación",
	"circles.invites.text.family": "ha consentido en invitarlos a su Círculo Familiar. Como miembro de Círculo Familiar usted recibirá acceso a información de salud personal y podrá comunicarse con otros miembros en el círculo familiar y también con los proveedores de atención médica.",
	"circles.invites.text.provider": "ha consentido invitarle a su Círculo de Proveedores. Como miembro de Círculo de Proveedores usted recibirá acceso a información personal de salud y podrá comunicarse con otros miembros en el círculo de proveedores y también con miembros de la familia.",
	"circles.invites.text.caregiver": "quiere asignarle un papel de Cuidador. Como Cuidador podrá responder a las encuestas dentro de los programas de {patient}, editar el perfil y utilizar la aplicación en nombre de {patient}.",
	"circles.invites.makeInviteToFamilyText": "Como miembro de su Círculo Familiar, el miembro de la familia a quien invita verá toda su información de salud y podrá comunicarse con su familia y el Círculo de Proveedores.",
	"circles.invites.makeInviteProviderText": "Como miembro de su Círculo de Proveedores, el miembro proveedor al que invita tendrá acceso a información personal de salud y podrá comunicarse con otros miembros del círculo de proveedores y también con los miembros de la familia.",
	"circles.invites.makeInviteCaregiverText": "El cuidador es capaz de responder encuestas dentro de sus programas, editar su perfil y utilizar el sistema de parte de ti.",
	"circles.invites.pending": "invitaciones pendientes",
	"circles.invites.caregiver": "El cuidador puede responder encuestas dentro de los programas del paciente, editar el perfil del paciente y usar el sistema en nombre del paciente.",
	"circles.circle": "Círculo",
	"circles.circle.typedCircle": "{type} círculo",
	"circles.titles.invitations": "Invitaciones",
	"circles.titles.listCaregiver": "Usted es cuidador de",
	"circles.titles.familyMemberingCircle": "Sus círculos familiares",
	"circles.titles.listFamilyCircleMember": "Círculos Familiares",
	"circles.titles.listProviderMember": "Es miembro del círculo de proveedores",
	"circles.titles.familyCircle": "",
	"circles.titles.providerCircle": "Círculo de proveedor",
	"circles.titles.primaryProviderProfileTitle": "Mi círculo de proveedor",
	"circles.titles.primaryPatientProfileTitle": "Mi círculos familiar",
	"circles.titles.caregiverRole": "Cuidador",
	"circles.titles.careProvider": "Proveedor de cuidado",
	"circles.family.cancelInvite.title": "¿Está seguro que desea cancelar la invitación a su círculo familiar?",
	"circles.family.cancelInvite.text": "Está a punto de cancelar la invitación de su {role} a su círculo familiar enviado por {login}. Una vez que la cancele, esta persona no podrá aceptarla y unirse a su círculo familiar.",
	"circles.caregiver.cancelInvite.title": "¿Está seguro de que quiere cancelar la invitación para ser un cuidador?",
	"circles.caregiver.cancelInvite.text": "Está a punto de cancelar la invitación de su {role} para ser un cuidador. Una vez que lo cancele, esta persona no podrá aceptarlo y convertirse en un cuidador.",
	"circles.actions.leave": "Deja el círculo",
	"circles.actions.leaveBtn": "Deja círculo",
	"circles.actions.makeCaregiver": "Asignar el papel de cuidador",
	"circles.actions.removeCaregiver": "Eliminar el papel de cuidador",
	"circles.actions.removeFromCircle": "Eliminar del círculo",
	"circles.actions.inviteProvider": "Invitar al miembro del proveedor",
	"circles.actions.inviteFamily": "Invitar a un miembro de la familia",
	"circles.leave.family.title": "¿Está seguro de que quiere dejar el círculo?",
	"circles.leave.family.body": "Estás a punto de dejar {patient} Círculos Familiar. Además, una vez que deje el círculo, ya no tendrá acceso ni podrá ver el Consejo de salud del {patient}.",
	"circles.leave.provider.title": "¿Está seguro de que quiere dejar el círculo?",
	"circles.leave.provider.body": "Está a punto de dejar {provider} Círculo de proveedor. Además, una vez que abandone el círculo, ya no tendrá acceso a la información de salud personal de {provider}.",
	"circles.roles.spouse": "Esposo/a",
	"circles.roles.daughter": "Hija",
	"circles.roles.son": "Hijo",
	"circles.roles.sister": "Hermana",
	"circles.roles.brother": "Hermano",
	"circles.roles.mother": "Madre",
	"circles.roles.father": "Padre",
	"circles.roles.granddaughter": "Nieta",
	"circles.roles.grandson": "Nieto",
	"circles.roles.grandmother": "Abuela",
	"circles.roles.grandfather": "Abuelo",
	"circles.roles.partner": "Compañero",
	"circles.roles.guardian": "Guardián",
	"circles.roles.relative": "Pariente",
	"circles.roles.friend": "Amigo",
	"circles.roles.power_of_attorney": "Poder legal",
	"circles.roles.patient": "Paciente",
	"circles.roles.caregiver": "Cuidador",
	"circles.roles.left_the_circle": "Dejó el círculo",
	"circles.roles.family_member": "Miembro de la familia",
	"circles.roles.single_care_provider": "Proveedor de cuidado individual",
	"circles.addProviderReason.temporaryTitle": "Acceso temporal",
	"circles.addProviderReason.permanentTitle": "Asignación permanente",
	"circles.addProviderReason.temporary.emergencyAccess": "Acceso de emergencia",
	"circles.addProviderReason.temporary.temporarilyAssigned": "temporalmente asignado al paciente",
	"circles.addProviderReason.temporary.patientConsultation": "Consulta del paciente",
	"circles.addProviderReason.permanent.underTreatment": "Paciente actual en tratamiento",
	"circles.addProviderReason.permanent.patientRequest": "Solicitud de paciente",
	"communities.empty.navigation": "No hay comunidades para navegar",
	"communities.empty": "No tienes comunidades",
	"communities.title.member": "My Comunidades",
	"communities.title.moderator": "Soy Moderador",
	"community.type.public": "Comunidad Pública",
	"community.type.private": "Comunidad Privada",
	"community.type.global": "Comunidad Global",
	"community.access.readOnly": "Solo lectura",
	"community.actions.createPost": "Nueva Publicación",
	"community.empty": "No hay tal comunidad",
	"community.description": "Sobre",
	"community.posts": "Publicaciones más recientes",
	"community.posts.empty": "No hay publicaciones todavía",
	"community.members": "miembros",
	"community.postUpdated": "actualizado",
	"community.activity.total": "Tienes {posts} publicación(es) nueva(s) y {comments} comentario(s) nuevo(s)",
	"community.activity.posts": "Tienes {posts} publicación(es) nueva(s)",
	"community.activity.comments": "Tienes {comments} comentario(s) nuevo(s)",
	"post.title": "Comentarios de publicación",
	"post.back": "Volver a la lista de publicaciones",
	"post.comments": "Comentarios",
	"post.comments.add": "Agregar comentario",
	"post.actions.createComment": "Publicar comentario",
	"post.actions.reply": "Respuesta",
	"post.comment.description": "comentó la publicación",
	"post.replies": "respuestas",
	"post.reply.description": "respondió al comentario de {name}",
	"post.reply.placeholder": "Responder al comentario...",
	"post.comments.empty": "No hay comentarios todavía",
	"community.newPost.title": "Nueva publicación en la comunidad {name}",
	"community.newPost.edit.title": "Editar publicación en la comunidad {name}",
	"community.newPost.caption": "Subtítulo",
	"community.newPost.attachImage": "Adjuntar imagen",
	"community.newPost.attachURL": "Adjuntar URL",
	"community.newPost.addPost": "Añadir publicación",
	"community.newPost.editPost": "Editar publicación",
	"community.newPost.fileError": "Solo se permiten imágenes de menos de {size}mb",
	"community.newPost.urlError": "Este enlace no es válido",
	"community.newPost.noPreview": "Sin vista previa",
	"community.newPost.enterUrl": "Introduzca aquí el url...",
	"community.postMenu.editPost": "Editar post",
	"community.postMenu.deletePost": "Eliminar mensaje",
	"community.postMenu.confirmDeleteMessage": "¿Seguro que quieres eliminar esta publicación? Esto no se puede deshacer.",
	"community.commentMenu.editComment": "Editar comentario",
	"community.commentMenu.deleteComment": "Eliminar comentario",
	"community.commentMenu.confirmDeleteComment": "¿Seguro que quieres eliminar esta comentario? Esto no se puede deshacer.",
	"community.comments.commentWasDeleted": "El comentario fue eliminado",
	"community.comments.commentWasDeletedByModerator": "El comentario fue eliminado por el moderador",
	"community.roles.moderator": "Moderador",
	"community.roles.member": "Miembro",
	"profile.fieldSet.empty": "La sección está vacía. Editar sección para agregar información.",
	"profiles.updated": "Perfil ha sido actualizado",
	"settings.updated": "La configuración ha sido actualizada",
	"programs.title": "Programas",
	"programs.emptyState": "no se ha asignado a ningún Programa todavía",
	"programs.invitation.emptyState": "No hay Programas disponibles para el",
	"programs.invitation.addPatient": "Añadir un Paciente a un Programa",
	"programs.invitation.invitationText": "le invita a unirse al Programa / Servicio",
	"programs.invitation.title": "Invitaciones de programa / servicio para {user}",
	"programs.invitation.empty": "No tienes invitaciones de programa / servicio",
	"programs.invitation.success": "El paciente se añade con éxito a los Programas",
	"programs.actions.request": "Invitaciones de programa / servicio",
	"programs.actions.title": "Detalles de programa / servicio para {user}",
	"programs.actions.followup": "Seguimiento de la cita para {user}",
	"programs.actions.subtitle": "Sobre programa / servicio",
	"programs.actions.showMore": "Leer Más",
	"programs.actions.showLess": "Leer Menos",
	"programs.actions.leave": "Dejar programa / servicio",
	"programs.actions.aboutProgram": "Acerca del programa",
	"programs.remove.confirmRemove": "¿Está seguro de que desea eliminar {nombre del paciente} del {programa}?",
	"programs.remove.success": "El paciente ha sido retirado con éxito del Programa",
	"programs.remove.title": "Sacar al Paciente del Programa",
	"programs.remove.subtitle": "Eliminar del Programa",
	"surveys.noUpcomingSurveys": "No tienes ninguna encuesta",
	"surveys.noSurveysResults": "No hay resultados para mostrar",
	"surveys.sent": "La encuesta ha sido enviada",
	"surveys.answer": "La encuesta ha sido respondida",
	"surveys.actions.answer": "Responder",
	"surveys.actions.save": "Guardar borrador",
	"surveys.actions.proceed": "Proceder",
	"surveys.actions.general": "Información de satisfacción del servicio",
	"surveys.actions.review": "Revisar",
	"surveys.actions.submit": "Presentar respuestas",
	"surveys.actions.upcoming": "Próximas encuestas",
	"surveys.actions.upcomingHeading": "Próximas encuestas para {user}",
	"surveys.sendSurvey.noSurveys": "No hay encuestas para enviar",
	"surveys.actions.exportToPDF": "Exportar a PDF",
	"surveys.title": "Encuestas",
	"surveys.results": "Resultados De La Encuesta",
	"surveys.single": "Encuesta",
	"surveys.totalScore": "Puntuación Total:",
	"surveys.selectedChatDesc": "La encuesta estará disponible para todos los miembros de la conversación seleccionado",
	"surveys.answeredBy": "Respondida por",
	"surveys.answerForm": "El formulario ha sido contestado",
	"surveys.noAvailableForms": "No hay formularios disponibles",
	"profile.actions.cancel": "Descarte",
	"profile.actions.details": "Ver perfil detallado",
	"profile.actions.submit": "Guardar cambios",
	"profile.actions.provider": "Proveedor",
	"profile.actions.patient": "Paciente",
	"profile.actions.back": "Consejo de salud del paciente",
	"profile.avatar.remove": "Retirar",
	"profile.avatar.upload": "Subir foto",
	"profile.avatar.update": "Actualizar foto",
	"profile.tabType.patient": "Perfil del usuario",
	"profile.tabType.provider": "Perfil del proveedor",
	"profile.tabType.surveys": "Encuestas generales",
	"profile.section.general": "Información general",
	"profile.section.personal": "Información personal",
	"profile.section.contacts": "Información del contacto",
	"profile.section.health": "Información de salud",
	"profile.section.prof": "Información profesional",
	"profile.section.mrns": "Números de registro médico",
	"profile.section.address": "Dirección del domicilio",
	"profile.section.notificationSettings": "Configuración de las notificaciones",
	"profile.section.languageSettings": "Configuración de idioma",
	"profile.fields.bio": "Bio",
	"profile.fields.location": "Ubicación",
	"profile.fields.phones": "Teléfonos",
	"profile.fields.healthInterests": "Intereses de salud",
	"profile.fields.name": "Nombre",
	"profile.fields.firstName": "Primer nombre",
	"profile.fields.middleName": "Segundo nombre",
	"profile.fields.lastName": "Apellido",
	"profile.fields.gender": "Género",
	"profile.fields.dob": "Fecha de nacimiento",
	"profile.fields.race": "Raza",
	"profile.fields.mStatus": "Estado civil",
	"profile.fields.ethnic": "Etnicidad",
	"profile.fields.language": "Idioma",
	"profile.fields.religion": "Religión",
	"profile.fields.email": "Correo electrónico",
	"profile.fields.homeAddress": "Dirección del domicilio",
	"profile.fields.address1": "Dirección 1",
	"profile.fields.address2": "Dirección 2",
	"profile.fields.city": "Ciudad",
	"profile.fields.state": "Estado",
	"profile.fields.postalCode": "Código postal",
	"profile.fields.country": "País",
	"profile.fields.homePhone": "Número de teléfono fijo",
	"profile.fields.mobilePhone": "Número de teléfono móvil",
	"profile.fields.localUid": "Números de Registro Médico",
	"profile.fields.allergies": "Alergias",
	"profile.fields.medicine": "Medicina",
	"profile.fields.healthGoals": "Metas de salud",
	"profile.fields.role": "Papel",
	"profile.fields.mrns": "Números de Registro Médico",
	"profile.fields.localUidProvider": "Proveedor ID",
	"profile.fields.npi": "Proveedor NPI",
	"profile.fields.title": "Título",
	"profile.fields.specialty": "Especialidad",
	"profile.fields.primaryPracticeAddress": "Dirección de Práctica primaria",
	"profile.fields.primaryPracticeAddress1": "Dirección de Práctica primaria 1",
	"profile.fields.primaryPracticeAddress2": "Dirección de Práctica primaria 2",
	"profile.fields.primaryPracticeCity": "Ciudad de Práctica Primaria",
	"profile.fields.primaryPracticeState": "Estado de Práctica Primaria",
	"profile.fields.primaryPracticeCountry": "País de Práctica Primaria",
	"profile.fields.officePhone": "Número de teléfono de la oficina",
	"profile.fields.username": "Usuario",
	"profile.fields.phoneNumber": "Teléfono móvil",
	"profile.fields.day": "Dia",
	"profile.fields.month": "Mes",
	"profile.fields.year": "Año",
	"profile.edit.emailConfirmationTitle": "Confirmar información de contacto",
	"profile.edit.emailConfirmationText": "Nosotros envió un correo electrónico de verificación a {email}. El correo electrónico antiguo se seguirá utilizando hasta que verifique el nuevo.",
	"profile.edit.confirmCode": "Confirmar código",
	"profile.edit.invalidCode": "Has ingresado un código no válido.",
	"profile.edit.phoneConfirmationText": "Para comenzar a usar el nuevo número de celular, necesitamos verificar lo. Hemos enviado un SMS con un código de confirmación a {phone}. Ingrese este código a continuación.",
	"profile.notificationSettings.label": "Notificar por {type} ({value})",
	"profile.notificationSettings.labels.email": "correo electrónico",
	"profile.notificationSettings.labels.sms": "SMS",
	"profile.list.gender.M": "Masculino",
	"profile.list.gender.F": "Femenino",
	"profile.list.gender.O": "Otro",
	"profile.list.gender.U": "Desconocido",
	"profile.list.marital.S": "Soltero",
	"profile.list.marital.M": "Casado",
	"profile.list.marital.O": "Otro",
	"profile.list.marital.U": "Desconocido",
	"chat.common.removeFromChat": "quitar de la conversación",
	"chat.actions.downloadAttachment": "Descargar archivo adjunto",
	"chat.actions.editMessage": "Editar mensaje",
	"chat.actions.deleteMessage": "Borrar mensaje",
	"chat.actions.confirmDeleteMessage": "¿Seguro que quieres borrar este mensaje? Esto no se puede deshacer.",
	"chat.actions.confirmLeaveChat": "¿Estás seguro de que quieres dejar esta conversación?",
	"chat.actions.reply": "Respuesta",
	"chat.actions.blockMessaging": "bloquear mensajes",
	"chat.actions.unblockMessaging": "desbloquear mensajes",
	"chat.actions.unblockUser": "Desbloquear usuario",
	"chat.actions.leaveChat": "dejar la conversación",
	"chat.titles.uploadingFile": "Estás subiendo un archivo {name}",
	"chat.titles.generalChatTab": "Círculo de Cuidado",
	"chat.titles.familyChatTab": "Sólo familia",
	"chat.titles.providersChatTab": "Sólo proveedores",
	"chat.titles.healthAlert": "Alerta de Salud",
	"chat.titles.notification": "Notificación",
	"chat.titles.surveyReminder": "Recordatorio",
	"chat.titles.addedAttachment": "añadido un archivo adjunto",
	"chat.titles.providers": "Proveedores",
	"chat.titles.family": "Familia",
	"chat.titles.memberAssignment": "Asignación de miembros",
	"chat.titles.providerAssignment": "Asignación de proveedor",
	"chat.titles.providerRemoved": "Proveedor sin asignar",
	"chat.title.chatName": "nombre de conversación",
	"chat.title.userBlocked": "No puedes enviar un mensaje a este contacto porque has sido bloqueado",
	"chat.placeholders.messageTo": "Mensaje para",
	"chat.placeholders.default": "Escribir un mensaje",
	"chat.placeholders.surveyExpired": "Esta encuesta expiró",
	"chat.notifications.patientAssignedToProgram": "{providerName} de {organizationName} ha inscrito {patientName} en el {programName} programa/servicio",
	"chat.notifications.patientRemovedFromProgram": "{patientName} se ha eliminado del programa / servicio {programName}",
	"chat.sorting.byUnread": "Por número de no leídos",
	"chat.sorting.byLastMessage": "Por más reciente",
	"chat.errors.tooLong": "Este mensaje es demasiado largo",
	"chat.errors.maxAttachmentSize": "Tamaño Máximo 50Mb",
	"chat.errors.maxAttachmentSizeNextPart": "{archivos} es / son demasiado grandes",
	"chat.errors.notAllowedFormat": "Solo puede subir jpg, png, pdf, docx, xlsx, pptx, rtf, txt, xml, mov, mp4 and vcf files",
	"chat.errors.uploadError": "Se ha producido un error durante la carga del archivo. Por favor, inténtelo de nuevo",
	"chat.errors.maxAttachmentNumber": "Solo puedes subir 20 archivos al mismo tiempo",
	"chat.moreAttachments.sendSurvey": "Enviar encuesta",
	"chat.moreAttachments.answerForm": "Responda el formulario",
	"chat.moreAttachments.attachFile": "Adjuntar archivo",
	"auth.accessDenied.text": "Lo sentimos, pero no tiene permisos para acceder a esta página.",
	"auth.createPassword.text": "Ingrese su nueva contraseña",
	"auth.expiredToken.text": "El enlace de registro caduca después de 7 días, y sólo se puede utilizar una vez.",
	"auth.expiredConfirmation.text": "El enlace de confirmación caduca después de 7 días, y sólo se puede utilizar una vez.",
	"auth.recoverConfirm.title": "Le hemos enviado un correo electrónico con instrucciones para ",
	"auth.recoverConfirm.confirmText": "Comprueba su correo electrónico, por favor",
	"auth.recoverConfirm.email.title": "Le hemos enviado un correo electrónico con instrucciones para ",
	"auth.recoverConfirm.email.confirmText": "Comprueba su correo electrónico, por favor",
	"auth.recoverConfirm.phone.title": "Le hemos enviado un mensaje con instrucciones para ",
	"auth.recoverConfirm.phone.confirmText": "Comprueba su teléfono móvil, por favor",
	"auth.recoverPassword.textTitle": "Ingrese su correo electrónico o número de teléfono y le enviaremos las instrucciones de recuperación de la contraseña.",
	"auth.recoverPassword.textLink": "Se le olvidó su contraseña?",
	"auth.userNotFound.text": "El usuario con este correo electrónico/teléfono no existe",
	"auth.signup.title": "¿No tiene una cuenta?",
	"auth.signup.textLink": "Se registre para {brandName}",
	"auth.tnc.title": "He leido y acepto",
	"auth.tnc.textLink": "Términos y Condiciones",
	"auth.logout.text": "Cerrar sesión",
	"errors.common": "Algo salió mal...",
	"errors.commonErrorOccured": "Se ha producido un error. Vuelve a intentarlo más tarde.",
	"errors.emailError": "Introduce una dirección de correo electrónico válida",
	"errors.emailErrorDesription": "Iniciar sesión {error}",
	"errors.invalidDateOfBirth": "Fecha de nacimiento invalida",
	"errors.login.unauthorized": "Usuario con combinación de inicio de sesión / contraseña no encontrada",
	"errors.login.authenticationLockout": "La autenticación está en bloqueo temporal para esta cuenta debido a demasiados intentos fallidos de inicio de sesión. Puedes volver a iniciar sesión en 15 minutos",
	"errors.nameLength": "El nombre y apellido deben contener hasta 40 símbolos",
	"errors.requiredFields": "Todos los campos son obligatorios",
	"errors.tnc": "Por favor, confirme que ha leído y aceptado los Términos y Condiciones.",
	"errors.cannotAcceptInvite": "Necesita tener un perfil de paciente para aceptar invitaciones a los círculos familiares",
	"errors.nicknameContainsCommercialAt": "El apodo no debe contener @ símbolo",
	"errors.password": "La contraseña no puede estar en blanco o contener sólo espacios",
	"errors.validation.profile.firstName.required": "Primer nombre debe estar presente",
	"errors.validation.profile.lastName.required": "El apellido debe estar presente",
	"errors.validation.profile.phone.format": "El teléfono debe contener solo +, - y dígitos",
	"errors.validation.profile.phone.required": "El teléfono debe estar presente",
	"errors.validation.profile.dob.format": "Formato de fecha incorrecto",
	"errors.validation.profile.dob.required": "Fecha de nacimiento requerida",
	"errors.validation.profile.email.format": "Correo electrónico no es válido, por favor proporcione otro",
	"errors.validation.profile.email.required": "Correo electrónico debe estar presente",
	"errors.validation.profile.username.required": "Usuario debe estar presente",
	"errors.validation.profile.username.format": "El nombre de usuario debe contener caracteres alfabéticos y numéricos",
	"errors.username.alreadyTaken": "Nombre de usuario ya ha sido tomado",
	"fields.dob": "Fecha de nacimiento",
	"fields.email": "Correo electrónico",
	"fields.gender": "Género",
	"fields.firstname": "Nombre",
	"fields.lastname": "Apellido",
	"fields.password": "Contraseña",
	"fields.username": "Apodo",
	"fields.login": "Login",
	"fields.login.placeholder": "Email or Teléfono",
	"fields.phoneNumber": "Teléfono",
	"submit.signup": "Proceder",
	"submit.login": "Iniciar sesión",
	"submit.fillProfile": "Confirmar",
	"submit.recoverPassword": "Enviar solicitud",
	"submit.recoverConfirm": "Volver al inicio de sesión",
	"submit.createPassword": "Guardar contraseña",
	"submit.expiredToken": "Lo tengo",
	"titles.accessDenied": "Acceso denegado",
	"titles.createPassword": "Crear nueva contraseña",
	"titles.expiredToken": "El enlace de registro ha caducado",
	"titles.expiredConfirmation": "El enlace de confirmación ha expirado",
	"titles.fillProfile": "Datos personales",
	"titles.login": "Iniciar sesión en {brandName}",
	"titles.recoverConfirm": "Enlace de recuperación enviado",
	"titles.recoverPassword": "Recuperar contraseña",
	"titles.signup": "Regístrate para {brandName}",
	"titles.confirmMyPhoneNumber": "Confirmo mi número de teléfono",
	"titles.confirmMyPhoneEmail": "Confirmo mi correo electrónico",
	"titles.confirmMyEmail": "Confirmo al correo electrónico",
	"general.careProvidersTitle": "Proveedores de cuidado",
	"previewableBlock.more": "Ver más",
	"previewableBlock.less": "Ver menos",
	"generalSurveys.noSurveys": "No tiene información de satisfacción del servicio",
	"intro.common.logout": "Haga clic aquí para salir de la aplicación",
	"intro.common.circlesMenu": "Invitar a alguien al círculo",
	"intro.circles.inviteFamilyMember": "Invitar a alguien a unirse al círculo familiar",
	"intro.circles.assignCaregiver": "Asignar a alguien como cuidador que puede actuar de parte del paciente",
	"intro.circles.inviteProviderMember": "Invitar a un proveedor de la organización a unirse al círculo",
	"intro.circles.removeProviderMember": "Quitar proveedor del círculo del proveedor",
	"intro.messages.generalChannel": "Haz clic en la pestaña para chatear con todos los proveedores y familiares",
	"intro.messages.providerChannel": "Chat privado sólo para proveedores",
	"intro.messages.familyChannel": "Chat privado solo para la familia del paciente",
	"intro.messages.searchChat": "Buscar un chat",
	"intro.messages.selectChat": "Seleccione un chat",
	"intro.messages.selectChannel": "Seleccione un canal",
	"intro.messages.typeFilter": "Selecciona un tipo de chats",
	"intro.messages.typeMessage": "Escriba su mensaje aquí",
	"intro.messages.answerSurvey": "Haga clic para responder a la encuesta",
	"intro.messages.patientName": "Haga clic en el nombre del paciente para ver los proveedores y programas",
	"intro.messages.patientContext": "Todo lo que ves está relacionado con este paciente",
	"intro.messages.patientProgram": "Haga clic para ver las encuestas del programa",
	"intro.messages.programFilter": "Filtra la lista de pacientes",
	"notificationScreen.title": "Aviso",
	"notificationScreen.providerWithoutPatients.notification": "Los círculos sólo están disponibles para los pacientes y sus familiares.",
	"notificationScreen.providerWithoutPatients.instructionTitle": "¿Cómo convertirse en un paciente o miembro de la familia (cuidador) en {brandName}?",
	"notificationScreen.providerWithoutPatients.instructionBody": "Para convertirse en un paciente, pregúntele a su médico si su clínica ya está conectada con {brandName} y, en caso afirmativo, pídales que lo inscriban en uno de los programas de atención {brandName} disponibles en su clínica. Para poder ser un miembro de la familia (cuidador) de un paciente, pida a sus familiares que ya están inscritos en el Programa de Atención {brandName}, que lo inviten a su círculo familiar.",
	"notificationScreen.providerWithoutPatients.commonTitle": "¿Ya es un paciente o un miembro de la familia?",
	"notificationScreen.providerWithoutPatients.commonBody": "Si ya ha sido inscrito en un programa por su médico, pero todavía no puede ver su tarjeta de salud, intente actualizar su dirección de correo electrónico.",
	"routes.patientViewProfile": "perfil del paciente",
	"routes.providerViewProfile": "perfil del proveedor",
	"routes.userViewProfile": "perfil de usuario",
	"routes.providerMemberProfile": "perfil de miembro de círculo de proveedor",
	"routes.familyMemberProfile": "perfil de miembro de la familia",
	"routes.generalSurveys": "encuestas generales",
	"routes.parentProvider": "proveedor de cuidado principal",
	"routes.patientInfo": "información del paciente",
	"routes.providerInfo": "información del proveedor",
	"routes.settings": "configuración",
	"messages.chat.searchByPeopleUsername": "Buscar por el nombre de usario",
	"messages.chat.enterUsernameOrName": "Ingresar el nombre de usuario de la persona con que desea iniciar una conversación",
	"messages.chat.newChat": "nueva conversación",
	"messages.chat.findAMember": "Encontrar un miemro",
	"messages.chat.youAddedMembers": "Agregó {counter} {counter, plural, one {miembro} other {miembros}}",
	"messages.chat.counterMembers": "{counter} {counter, plural, one {mimebro} other {miembros}}",
	"messages.chat.startANewConversationInTheContextOf": "Comenzar una nueva conversación en el contexto de {user}",
	"messages.chat.startANewConversationInTheContextOfDesc": "Las personas que se enumeran a continuación están en el Círculo de atención y se puede agregar a otros no en Círculos mediante la búsqueda",
	"messages.chat.startANewConversation": "Comenzar una nueva conversación",
	"messages.chat.start": "Comenzar",
	"messages.chat.noOneFound": "nadie encontró",
	"circle.notInCircle": "No en {contextUser}’s provider CÍRCULO",
	"chat.title.chatInContextOf": "Conversar en el contexto de",
	"chat.title.inContextOf": "En el contexto de",
	"chat.title.conversationInfo": "Información de conversación",
	"chat.notification.newMessage": "Nuevo mensaje",
	"chat.titles.activitiesChatTab": "Ocupaciones",
	"chat.titles.notificationsChatTab": "Notificaciones/Alertas",
	"role.admin": "admin",
	"dialog.common.invite": "Invitar a más personas a la conversación",
	"dialog.success.joinCircle": "Te has unido al círculo de Proveedores de Pacientes.",
	"dialog.titles.joinCircle": "Unirse al Círculo de Proveedores de un Paciente",
	"dialog.titles.assignProviderToPatient": "Asignar nuevo Proveedor al Paciente",
	"dialog.common.noPatients": "Si el paciente no aparece en la búsqueda, puede que no esté en nuestro sistema o puede que ya esté asignado a usted.",
	"dialog.common.assign": "Asignar",
	"dialog.common.addPatient": "Añadir pacientes al sistema",
	"dialog.common.defaultPatient": "INGRESE EL NOMBRE DE USUARIO O NOMBRE DE UN PACIENTE CUYO CÍRCULO DE PROVEEDORES DESEA UNIRSE",
	"dialog.common.addNewPatient": "Añadir nuevo paciente",
	"dialog.common.defaultProvider": "INGRESE EL NOMBRE DE USUARIO O NOMBRE DE UN PROVEEDOR QUE LE GUSTARÍA ASIGNAR AL PACIENTE",
	"dialog.common.assignProvider": "Asignar Proveedor",
	"dialog.common.inviteCaregiver": "Invitar Cuidador",
	"dialog.common.searchProvider": "Búsqueda de un Proveedor...",
	"dialog.common.searchPatient": "Búsqueda de un Paciente...",
	"dialog.common.addAnotherPatient": "¿Quieres añadir otro Paciente al sistema?",
	"dialog.titles.addPatient": "Añadir Paciente",
	"dialog.titles.andOr": "y/o"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/es.json
// module id = 5358
// module chunks = 39